import axios from "../utils/request";
const apiPrefix = "/import";

export const getImportSchema = (model) => {
  return axios.get(`${apiPrefix}/schema`, {
    params: { model },
  });
};
export const importHostData = (data) => {
  console.log("importHostData data length:", data.length);
  console.log("importHostData data type:", typeof data);
  console.log("importHostData data 0:", data[0]);
  // return axios.post(`${apiPrefix}/host`, { data });
};
